import axios from "axios";
import { CURRENT_API_URL } from "../../../Utils/Constants";
import notify from "../../../../src/Notifications/ToastifyActions";

function FetchAccountHealthReportService(token, data) {
    return axios
        .post(
            `${CURRENT_API_URL}/sellerPartner/fetchAccountHealthReport`,
            data,
            {
                headers: {
                    Authorization: token,
                },
            }
        )
        .then((res) => {
            notify.NotifySuccess("Amazon Health Report is successfully requested. System will be updated on report processing finished notification. Please try again after some time for updated status.");
            return res.data;
        })
        .catch((error) => {
            console.log(error);
            throw error;
        });
}

export default FetchAccountHealthReportService;